<template lang="pug">
.modal(:class="{ 'is-active': value }")
  .modal-background(@click="$emit('input', false)")
  slot
  button.modal-close.is-large(aria-label="close" @click="$emit('input', false)")
</template>

<script>
export default {
  name: "modal-component",

  props: ["value"]
};
</script>
